/**
 * Hoffmaster Timeline Widget Handler
 * Handles "View More" button functionality and item visibility.
 */

class HoffmasterTimelineHandler extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				wrapper: '.hm-timeline-wrapper',
				timeline: '.hm-timeline',
				viewMoreContainer: '.hm-timeline-view-more',
				viewMoreButton: '.hm-timeline-view-more__button',
				hiddenItem: '.hm-timeline-item--hidden',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings('selectors');
		return {
			$wrapper: this.$element.find(selectors.wrapper),
			$timeline: this.$element.find(selectors.timeline),
			$viewMoreContainer: this.$element.find(selectors.viewMoreContainer),
			$viewMoreButton: this.$element.find(selectors.viewMoreButton),
		};
	}

	bindEvents() {
		if (!this.elements.$viewMoreButton.length || !this.elements.$wrapper.length) {
			return;
		}

		// Handle View More button click
		this.elements.$viewMoreButton.on('click', () => this.handleViewMore());
	}

	handleViewMore() {
		// Add expanded class to wrapper to trigger animations
		this.elements.$wrapper.addClass('hm-timeline-wrapper--expanded');

		// Fade out the view more button
		if (this.elements.$viewMoreContainer.length) {
			this.elements.$viewMoreContainer.fadeOut(400);
		}

		// After animation completes, ensure overflow is visible for proper layout
		setTimeout(() => {
			this.elements.$timeline.css('overflow', 'visible');
		}, 800);
	}
}

jQuery(window).on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler('hm_timeline', HoffmasterTimelineHandler);
});
